<template>
  <div class="signin-wrapper">
    <div class="temp1"></div>
    <div v-if="isIframe" class="icon-wrapper">
      <v-icon class="v-icon start" @click="onBack">mdi-arrow-left-bold</v-icon>
      <div class="escape-wrapper">
        <v-icon class="v-icon end" @click="onCloseIframe">mdi-close</v-icon>
      </div>
    </div>
    <div class="sign-in-main">
      <div v-if="token" class="login-success">
        <span class="login-success-message">Login Success!!</span>
      </div>
      <SignInCard v-else class="signin-card" />
    </div>
  </div>
</template>

<script>
import SignInCard from "../components/SignInCard";
import { mapGetters, mapState } from "vuex";
import keyBy from "lodash.keyby";

export default {
  name: "SignInWindow",
  components: {
    SignInCard,
  },
  computed: {
    ...mapGetters(["token", "isIframe", "iframeParentUrl", "products"]),
    ...mapState(["iframeProducts"]),
    productsToSendToIframe() {
      if (this.token) {
        return this.products.filter(
          (product) => product.merchantUrl === this.iframeParentUrl
        );
      }
      return this.iframeProducts;
    },
  },
  methods: {
    onCloseIframe() {
      parent.postMessage(
        {
          message: "closeIframe",
          items: keyBy(this.productsToSendToIframe, "shopifyVariantId"),
        },
        "*"
      );
    },
    onBack() {
      this.$router.push({ path: "/sharing" });
    },
  },
};
</script>

<style scoped>
.signin-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.login-success-message {
  font-size: 40px;
  font-weight: 700;
  font-family: graphik lcg, proxima-nova, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  line-height: 1.25;
  margin-top: 10px;
}

.sign-in-main {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: space-between;
  padding: 5%;
}

.icon-wrapper {
  display: flex;
}

.icon-wrapper-start {
  display: flex;
}

.signin-card {
  align-self: center;
}

.v-icon.start {
  align-self: flex-start;
  margin-left: 31px;
  margin-top: 31px;
}

.v-icon.end {
  align-self: flex-end;
  margin-right: 31px;
  margin-top: 31px;
}
.escape-wrapper {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.temp1 {
  background: url(../../images/wallpaper/items-background.jpg);
  opacity: 0.05;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
}
</style>
